import { useEffect } from "react";

export const useSubscribeProducts = (productData, setIsSubscribe) => {
  useEffect(() => {
    const enabled = !!productData.subscription?.subscription_enable;
    setIsSubscribe(enabled);
    productData.setProductsBySubscription(enabled);
  }, [productData.subscription?.subscription_enable]);
};
